require('./dist/autocomplete.min.js');
module.exports = 'google.places';


//////////////////
// WEBPACK FOOTER
// ./~/angular-google-places-autocomplete/index.js
// module id = 240
// module chunks = 0